import React, { useState } from 'react';
import styled from 'styled-components';
import FaInfoCircle from '../../components/FaInfoCircle';
import { FaCalculator } from '../../components/Icons';
import { SectionHeaderComp } from './LastresLigaPage';

const CollapsibleBox = styled.div`
  margin-bottom: 24px;
  border: 1px solid #c0c0c0;
  border-radius: 8px;
  background: #fafbfc;
  box-shadow: 0 2px 8px rgba(16,19,37,0.04);
`;

const ToggleButton = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: #101325;
  font-size: 1.1rem;
  font-weight: bold;
  padding: 16px;
  text-align: left;
  display: flex;
  align-items: center;
  cursor: pointer;
  outline: none;
  transition: background 0.2s;
  border-radius: 8px 8px 0 0;
  &:hover {
    background: #f0f1f5;
  }
  svg {
    margin-right: 10px;
    color: #e4312e;
  }
`;

const Content = styled.div`
  padding: 16px 24px 24px 24px;
  font-size: 1rem;
  color: #31344b;
`;

const LastresInstrucciones: React.FC = () => {
  const [open, setOpen] = useState(false);
  return (
    <CollapsibleBox>
      <SectionHeaderComp icon={<FaCalculator style={{ color: '#e4312e' }} />}>
        Lastres VRS
      </SectionHeaderComp>
      <ToggleButton onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(o => !o);
      }} aria-expanded={open}>
        <FaInfoCircle />
        {open ? 'Ocultar instrucciones de lastres' : '¿Qué son los lastres y cómo funcionan? (Instrucciones detalladas)'}
      </ToggleButton>
      {open && (
        <Content>
          <h2>¿Qué es el lastre en simracing?</h2>
          <p>
            El <b>lastre</b> es un sistema utilizado en competiciones de simracing (y automovilismo real) para equilibrar el rendimiento de los pilotos. Consiste en añadir peso extra a los coches de los pilotos más rápidos o exitosos, con el objetivo de igualar las oportunidades y aumentar la competitividad.
          </p>
          <h3>¿Por qué se utiliza?</h3>
          <ul>
            <li>Evita que un solo piloto domine todas las carreras.</li>
            <li>Promueve la igualdad de oportunidades.</li>
            <li>Hace que la liga sea más emocionante y disputada.</li>
          </ul>
          <h3>Tipos de lastre en esta liga</h3>
          <ul>
            <li><b>Lastre por posición:</b> Se asigna un peso extra según la posición final en la carrera anterior o la clasificación general. Por ejemplo, el primer clasificado recibe más kg, el segundo algo menos, etc.</li>
            <li><b>Reducción por resultado de equipo:</b> Si el equipo obtiene un buen resultado, el piloto puede recibir una reducción de lastre.</li>
            <li><b>Aplicación por carreras:</b> El sistema puede configurarse para aplicar lastres solo en ciertas carreras, o bajo ciertas condiciones (por ejemplo, descartar el peor resultado).</li>
          </ul>
          <h3>¿Cómo se calcula el lastre?</h3>
          <ol>
            <li>Se consulta la <b>tabla de lastre</b> para ver cuántos kg corresponden a cada posición.</li>
            <li>Se suman o restan los kg según los resultados de equipo si aplica.</li>
            <li>Se aplican las reglas especiales de la liga (por ejemplo, carreras sin lastre, descartar el peor resultado, etc.).</li>
            <li>El peso total se asigna al piloto para la siguiente carrera.</li>
          </ol>
          <h3>Ejemplo práctico</h3>
          <p>
            Si un piloto termina 2º y su equipo gana la carrera, puede recibir el lastre de la 2ª posición y una reducción adicional por el resultado de equipo. Si la carrera está marcada como "sin lastre", no se aplica ningún peso.
          </p>
          <h3>Glosario</h3>
          <ul>
            <li><b>Lastre</b>: Peso extra que se añade a un coche.</li>
            <li><b>Reducción</b>: Kg que se restan al lastre por circunstancias especiales (ej: resultado de equipo).</li>
            <li><b>Aplicación</b>: Reglas sobre cuándo y cómo se aplica el lastre.</li>
            <li><b>Descartar peor resultado</b>: No se tiene en cuenta la peor carrera del piloto para el cálculo del lastre.</li>
          </ul>
          <h3>¿Qué debo tener en cuenta como piloto?</h3>
          <ul>
            <li>El lastre se calcula automáticamente según los resultados y la configuración de la liga.</li>
            <li>Puedes consultar en esta sección cuántos kg te corresponden y cómo se ha calculado.</li>
            <li>Si tienes dudas, revisa estas instrucciones o consulta a la organización de la liga.</li>
          </ul>
        </Content>
      )}
    </CollapsibleBox>
  );
};

export default LastresInstrucciones;
